import callApi from '../../utils/api';
import { API_BASE_URL } from '../../utils/constants';
import {parseParams} from '../../utils'
import { patchProfile } from '../../devtools/devtoolsState';

const api = callApi(API_BASE_URL || "");

export const GET_PROFILE_INFO = '/v1/api/user/users/profile?{{query}}';
export const UPDATE_PROFILE = {
    students: '/v1/api/user/students/profile/ir/{{id}}',
    teachers: '/v1/api/user/teachers/{{id}}'
}

export const getProfileInfo = async (payload) => {
   
    let query = {};
    if(payload && payload.payload) {
        query = {...payload.payload};
    }
    let params = new URLSearchParams(query).toString();
    return patchProfile(await api.get(parseParams(GET_PROFILE_INFO, {query: params})));
}

export const updateProfile = async (payload) => {
    const {body, id, role} = payload;

    let endpoint = UPDATE_PROFILE[role || 'students'];

    return await api.put(parseParams(endpoint, {id}), body);
}